// ===============================
// App.js
// ===============================

import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import EcommerceHeader from "./Components/Header/EcommerceHeader.jsx";
import EcommerceFooter from "./Components/Footer/EcommerceFooter";
// PAGES
import Home from "./Components/Home/Home";
import Shop from "./Components/Shop/Shop.jsx";
import Contact from "./Components/Pages/Contact";
import Deals from "./Components/Pages/Deals";
import Categories from "./Components/Pages/Categories";
import Trending from "./Components/Pages/Trending";
import NewArrivals from "./Components/Pages/NewArrivals";
import Cart from "./Components/Cart/Cart.jsx";
import ProductDetails from "./Components/Pages/ProductDetails.jsx";
function App() {
  return (
    <BrowserRouter>

      {/* HEADER */}
      <EcommerceHeader />

      {/* ROUTES */}
      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/shop" element={<Shop />} />

        <Route
          path="/new-arrivals"
          element={<NewArrivals />}
        />

        <Route
          path="/trending"
          element={<Trending />}
        />

        <Route
          path="/categories"
          element={<Categories />}
        />

        <Route path="/deals" element={<Deals />} />
<Route
  path="/product/:id"
  element={<ProductDetails />}
/>
        <Route
          path="/contact"
          element={<Contact />}
        />
<Route
          path="/cart"
          element={<Cart />}
        />
      </Routes>
    <EcommerceFooter />
    </BrowserRouter>
  );
}

export default App;